import { ListSortLabelModel } from './label.model';

export class ListSortSetAvailableAction {
  constructor(public available: ListSortLabelModel[]) {}
}
